import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

interface CourseStatusChartProps {
  notStarted: number;
  inProgress: number;
  completed: number;
}

const CourseStatusChart: React.FC<CourseStatusChartProps> = ({ notStarted, inProgress, completed }) => {
  const data = [
    { name: 'Not Started', value: notStarted, color: 'hsl(var(--muted-foreground))' },
    { name: 'In Progress', value: inProgress, color: 'hsl(var(--primary))' },
    { name: 'Completed', value: completed, color: 'hsl(var(--success))' }
  ].filter(item => item.value > 0);

  if (data.length === 0) {
    return (
      <div className="flex items-center justify-center h-[300px] text-muted-foreground">
        No course data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default CourseStatusChart;
